import { createAsyncThunk } from '@reduxjs/toolkit';
import { DanoneService } from '@bvt-features/danone/service/danoneService';
import axios from 'axios';

const danoneService = new DanoneService();

export const getResultAreaProfiling = createAsyncThunk(
  'LI/DANONE/AREA-PROFILING/GET_RESULT_AREA_PROFILING',
  async (param, { rejectWithValue }) => {
    try {
      const response = await danoneService.getResultAreaProfiling(param);
      if (response.data.error) {
        return rejectWithValue(response.data);
      }
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAhsMArkers = createAsyncThunk(
  'LI/DANONE/AREA-PROFILING/GET_MARKERS',
  async (param, { rejectWithValue }) => {
    try {
      const response = await danoneService.getAhsMarkers(param);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const downloadSummary = createAsyncThunk(
  'LI/DANONE/AREA-PROFILING/DOWNLOAD_SUMMARY',
  async (param, { rejectWithValue }) => {
    try {
      const response = await danoneService.downloadSummary(param);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const doDownloadVillageResult = createAsyncThunk(
  'LI/DANONE/AREA-PROFILING/DO_DOWNLOAD_VILLAGE_RESULT',
  async (param, { rejectWithValue }) => {
    try {
      const resp = await axios.get(param.url, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      return { url, filename: param.filename };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const doDownloadCatchmentResult = createAsyncThunk(
  'LI/DANONE/AREA-PROFILING/DO_DOWNLOAD_CATCHMENT_RESULT',
  async (param, { rejectWithValue }) => {
    try {
      const resp = await axios.get(param.url, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      return { url, filename: param.filename };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
